import React, {Component} from "react";
import {Table, Icon, Row, Col, Tabs, message} from 'antd';
import style from './index.css';
import NHFetch from "../../../utils/NHFetch";
import getSize from "../../../utils/getSize";

const TabPane = Tabs.TabPane;

const basicUrl = "/hjfp/"; //基础路径

/**
 * 环节分配编辑表单
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-03-17 16:49:01
 * Version: 1.0
 * Modify log:
 */
class EditForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            lcpzData: [], //流程环节信息
            formData:{}, //已选择的流程环节
            activeKey: '0' //当前显示的Tab
        }
    }

    componentDidMount() {
        NHFetch(basicUrl + 'getLcpz', 'GET')
            .then(res => {
                if (res) {
                    this.setState({lcpzData: res.data});
                }
            })
    }

    //校验是否选中流程环节
    validate = (callback) => {
        const values = new Set();
        const formData = this.state.formData;
        for(let key in formData) {
            for(let index in formData[key]) {
                values.add(formData[key][index]);
            }
        }

        if(values.size == 0) {
            message.error('请先选择流程环节！');
            return false;
        }else{
            callback(Array.from(values));
        }

    }

    //创建子面板
    buildTabPanes = () => {
        const {lcpzData} = this.state;
        const panes = [];
        const columns = [
            {
                title: '步骤',
                key: 'bz',
                dataIndex: 'bz',
                width: '60px'
            }, {
                title: '环节名称',
                key: 'hjmc',
                dataIndex: 'hjmc',
            }, {
                title: '是否必须办理',
                key: 'hjlb',
                dataIndex: 'hjlb',
                width: '150px',
                render: (text, record) => {
                    const icon = text == '1' ? <Icon type="check-circle" style={{fontSize: 16, color: '#53c41a'}}/>
                        : <Icon type="close-circle" style={{fontSize: 16, color: '#ff4d4f'}}/>

                    return icon;
                }
            }
        ];

        //选中行事件
        const rowSelection = {
            onChange: (selectedRowKeys, selectedRows) => {
                const formData = {...this.state.formData};
                formData[this.state.activeKey] = selectedRowKeys;
                this.setState({formData:formData});
            }
        };

        if (lcpzData == null || lcpzData.length == 0) {
            panes.push(
                <TabPane tab={'暂无流程环节信息，请先配置流程！'} key={"0"}>
                    <p></p>
                </TabPane>
            );
        } else {
            for (let key in lcpzData) {
                let lcmc = lcpzData[key].lcdyVO.lcmc; //流程信息
                let lchjVOs = lcpzData[key].lchjVOs; //流程环节

                panes.push(
                    <TabPane tab={lcmc} key={key}>
                        <Table rowSelection={rowSelection} rowKey={record => record.pkid} dataSource={lchjVOs}
                               columns={columns} pagination={false} scroll={{y:getSize().windowH - 398}}/>
                    </TabPane>
                );
            }
        }

        return panes;

    }

    render() {

        const initFormData = this.props.initFormData;
        const tabPanes = this.buildTabPanes(); //子面板

        return (
            <div>
                <Row type="flex" justify="center">
                    <Col span={24}>
                        <Tabs defaultActiveKey="0" onChange={(activeKey)=>{this.setState({activeKey:activeKey})}}>
                            {[...tabPanes]}
                        </Tabs>
                        <div className={style["bottom-description"]}>
                            <p>说明：一个用户可以参与多个流程的多个环节</p>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default EditForm;


// WEBPACK FOOTER //
// ./components/lcgl/hjfp/EditForm.js